import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { isMobile } from "./style";

const Footer: React.FC = () => {
  return (
    <Footers>
      <Nav>
        <NavLinks
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/"
        >
          똥 피하기 게임
        </NavLinks>
      </Nav>
      <>
        <NavLinks
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/dev"
        >
          개발자
        </NavLinks>
      </>
    </Footers>
  );
};

export default Footer;

const Footers = styled.div`
  background: #c8e4ff;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 95px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  ${isMobile} {
    height: 70px;
  }
`;

const Nav = styled.div`
  border-right: 1px solid #bad9f6;
`;

const NavLinks = styled(NavLink)`
  color: #a6c5e2;
  font-family: "GmarketSansBold";
  font-size: 23px;
  font-weight: 700;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &:hover {
    color: #8abbe9;
  }

  &.active {
    color: #8abbe9;
  }

  ${isMobile} {
    font-size: 18px;
  }
`;
